
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___ar",
    path: "/ar/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___cav",
    path: "/cav/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___mr",
    path: "/mr/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___fr",
    path: "/fr/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ms",
    path: "/ms/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___far",
    path: "/far/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ha",
    path: "/ha/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___gr",
    path: "/gr/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___end",
    path: "/end/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___bn",
    path: "/bn/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___kr",
    path: "/kr/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___nl",
    path: "/nl/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ta",
    path: "/ta/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___bsn",
    path: "/bsn/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___cav",
    path: "/cav",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___mr",
    path: "/mr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___far",
    path: "/far",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ha",
    path: "/ha",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___gr",
    path: "/gr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___end",
    path: "/end",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___bn",
    path: "/bn",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___kr",
    path: "/kr",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ta",
    path: "/ta",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___bsn",
    path: "/bsn",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___ar",
    path: "/ar/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___cav",
    path: "/cav/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___mr",
    path: "/mr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ru",
    path: "/ru/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ms",
    path: "/ms/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___far",
    path: "/far/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ha",
    path: "/ha/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___gr",
    path: "/gr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___end",
    path: "/end/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___bn",
    path: "/bn/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___kr",
    path: "/kr/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___nl",
    path: "/nl/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ta",
    path: "/ta/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___bsn",
    path: "/bsn/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___cav",
    path: "/cav/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___mr",
    path: "/mr/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ms",
    path: "/ms/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___far",
    path: "/far/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ha",
    path: "/ha/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___gr",
    path: "/gr/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___end",
    path: "/end/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___bn",
    path: "/bn/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___kr",
    path: "/kr/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___nl",
    path: "/nl/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ta",
    path: "/ta/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___bsn",
    path: "/bsn/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "slug___ar",
    path: "/ar/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___cav",
    path: "/cav/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___mr",
    path: "/mr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ms",
    path: "/ms/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___far",
    path: "/far/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ha",
    path: "/ha/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___gr",
    path: "/gr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___end",
    path: "/end/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___bn",
    path: "/bn/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___kr",
    path: "/kr/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___ta",
    path: "/ta/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___bsn",
    path: "/bsn/:slug(.*)*",
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/cav/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/mr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ms/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/far/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ha/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/gr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/end/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/bn/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/kr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ta/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/bsn/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]